<script setup lang="ts">
import { PLANS } from '~/utils/constants'
definePageMeta({
  layout: 'default',
})

useSiteSeoMeta({
  title: 'Pricing',
  description: 'Affordable plans for your TCF Canada preparation.',
})

const plans = PLANS
</script>

<template>
  <div class="py-24 bg-gray-50 dark:bg-gray-950 min-h-screen">
    <UContainer>
      <div class="text-center max-w-2xl mx-auto mb-16">
        <h1 class="text-4xl font-bold mb-4">Simple, Transparent Pricing</h1>
        <p class="text-gray-600 dark:text-gray-400 text-lg">
          Choose the plan that fits your study schedule. Upgrade or cancel anytime.
        </p>
      </div>

      <div class="grid md:grid-cols-3 gap-8">
        <UCard
          v-for="plan in plans"
          :key="plan.name"
          :class="[
            'relative flex flex-col',
            plan.popular
              ? 'ring-2 ring-primary-500 shadow-xl scale-105 z-10'
              : 'hover:shadow-lg transition-shadow',
          ]"
        >
          <div v-if="plan.popular" class="absolute top-0 right-0 -mr-2 -mt-2">
            <UBadge color="primary" variant="solid" size="md">Most Popular</UBadge>
          </div>

          <div class="mb-6">
            <h3 class="text-xl font-bold mb-2">{{ plan.name }}</h3>
            <p class="text-gray-500 text-sm mb-4 min-h-[40px]">{{ plan.description }}</p>
            <div class="flex items-baseline gap-1">
              <span class="text-4xl font-bold">{{ plan.price }}</span>
              <span v-if="plan.period" class="text-gray-500 text-sm">{{ plan.period }}</span>
            </div>
          </div>

          <div class="grow">
            <ul class="space-y-3 mb-8">
              <li
                v-for="feature in plan.features"
                :key="feature"
                class="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-300"
              >
                <UIcon name="i-heroicons-check-circle" class="w-5 h-5 text-primary-500 shrink-0" />
                {{ feature }}
              </li>
            </ul>
          </div>

          <UButton
            :color="plan.color as any"
            block
            size="lg"
            :variant="plan.popular ? 'solid' : 'outline'"
          >
            {{ plan.button }}
          </UButton>
        </UCard>
      </div>
    </UContainer>
  </div>
</template>
